const enum PaginationResults {
    DEFAULT = 20
}

export default PaginationResults;
